import React, { memo, useContext } from 'react'
import { pushWithCruiseFilters } from 'actions/CruiseActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import noop from 'lib/function/noop'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import CruiseSearchInputs from './Inputs/CruiseSearchInputs'

interface Props {
  open: boolean
  onClose?: () => void
  searchPage?: string
  isCruiselineLandingPage?: boolean
}

function CruiseSearchFiltersDrawer({
  open,
  searchPage,
  isCruiselineLandingPage,
  onClose = noop,
}: Props) {
  const globalSearch = useContext(GlobalSearchStateContext)
  const queryParams = useQueryParams()
  const dispatch = useAppDispatch()

  const onSubmit = () => {
    dispatch(pushWithCruiseFilters(searchPage ?? '/search/cruises', globalSearch, queryParams))
    onClose?.()
  }

  return <ModalBase
    isOpen={open}
    onClose={onClose}
    mode="drawer"
  >
    <ModalHeader
      title="Filters"
      onCloseButtonClick={onClose}
    />
    <ModalBody>
      <ModalContent>
        <Group direction="vertical" gap={8}>
          <CruiseSearchInputs drawerMode isCruiselineLandingPage={isCruiselineLandingPage} />
        </Group>
      </ModalContent>
    </ModalBody>
    <ModalFooter>
      <TextButton
        kind="primary"
        type="submit"
        size="large"
        onClick={onSubmit}
      >
        Search
      </TextButton>
    </ModalFooter>
  </ModalBase>
}

export default memo(CruiseSearchFiltersDrawer)
